// This file is generated by Style Dictionary
const tokens = {
  analytics: {
    first: '#8a76e8',
    second: '#e96b7c',
    third: '#3b8880',
  },
  brand: {
    accent: {
      option1: '#9cc7f2',
      option2: '#2e7e32',
      option3: '#f2e93f',
      option4: '#ff7b6d',
    },
    business: '#271a38',
    official: '#8a76e8',
    onContrasted: '#fffaee',
    primary: '#7451eb',
    secondary: '#8a76e8',
    gradient: {
      blueGreen:
        'linear-gradient(90.0deg, rgba(156, 199, 242, 1.0) 0%, rgba(90, 148, 96, 1.0) 100%)',
      greenYellow:
        'linear-gradient(90.0deg, rgba(90, 148, 96, 1.0) 0%, rgba(242, 233, 63, 1.0) 100%)',
      pinkRed:
        'linear-gradient(90.0deg, rgba(237, 179, 178, 1.0) 0%, rgba(255, 123, 109, 1.0) 100%)',
      pinkViolet:
        'linear-gradient(90.0deg, rgba(237, 179, 178, 1.0) 0%, rgba(157, 169, 243, 1.0) 100%)',
      violetBlue:
        'linear-gradient(90.0deg, rgba(157, 169, 243, 1.0) 0%, rgba(156, 199, 242, 1.0) 100%)',
      violetRed:
        'linear-gradient(90.0deg, rgba(157, 169, 243, 1.0) 0%, rgba(255, 123, 109, 1.0) 100%)',
      yellowOrange:
        'linear-gradient(90.0deg, rgba(242, 233, 63, 1.0) 0%, rgba(249, 171, 45, 1.0) 100%)',
    },
  },
  chip: {
    disclose: {
      background: {
        enabled: '#f6f4fd',
        error: '#fcebeb',
      },
      border: {
        enabled: '#dad9dc',
        error: '#fcebeb',
      },
      input: '#271a38',
    },
  },
  content: {
    data: {
      first: '#7451eb',
      fourth: '#3b8880',
      second: '#ea7000',
      third: '#e96b7c',
    },
    highlight: {
      firstLevel: {
        background: '#ecf7fd',
        main: '#129ce7',
      },
      fourthLevel: {
        background: '#fffaee',
        main: '#f9ab2d',
      },
      information: {
        background: '#ecf7fd',
        main: '#129ce7',
      },
      promotion: {
        background: '#fdfbe0',
        main: '#f2e93f',
      },
      secondLevel: {
        background: '#fdfbe0',
        main: '#f2e93f',
      },
      thirdLevel: {
        background: '#f6f4fd',
        main: '#9da9f3',
      },
    },
  },
  creativeAssets: {
    detail: '#ece9fb',
    thumbnail: '#dad3f8',
  },
  form: {
    field: {
      background: {
        activeDrop: '#7451eb29',
        disabled: '#f9f8f9',
        enabled: '#ffffff',
        error: {
          enabled: '#fdf5f5',
          hover: '#fcebeb',
        },
        locked: '#f9f8f9',
      },
      border: {
        disabled: '#c3bfc7',
        enabled: '#c3bfc7',
        error: {
          enabled: '#d50000',
          hover: '#950000',
        },
        focus: '#7451eb',
        hover: '#7451eb',
        locked: '#c3bfc7',
      },
      input: '#271a38',
      placeholder: '#605b68',
    },
    label: {
      disabled: '#605b68',
      empty: '#271a38',
      error: '#d50000',
      filled: '#605b68',
      focus: '#7451eb',
      helper: '#605b68',
      locked: '#605b68',
    },
    selection: {
      icon: {
        disabled: '#605b68',
        enabled: '#271a38',
        error: '#d50000',
        minor: '#605b68',
        selected: '#7451eb',
      },
      text: {
        disabled: '#605b68',
        enabled: '#271a38',
      },
    },
  },
  icon: {
    disabled: '#605b68',
    disclosureIndicator: '#605b68',
    error: '#d50000',
    minor: '#605b68',
    onContrasted: '#fffaee',
    onContrastedHighlighted: '#fffaee',
    onMain: '#271a38',
    onMainHighlighted: '#7451eb',
  },
  interaction: {
    border: '#dad9dc',
    danger: '#d50000',
    disabled: '#7451eb61',
    enabled: '#7451eb',
    filter: '#ffffff',
    floatingMenu: {
      disabled: '#f6f4fd',
      enabled: '#f6f4fd',
      hover: '#ece9fb',
      onDisabled: '#7451eb61',
      onEnabled: '#7451eb',
      onHover: '#7451eb',
    },
    hover: '#7451eb',
    navigationEnabled: '#271a38',
    onContrasted: {
      disabled: '#fffaee61',
      enabled: '#fffaee',
      hover: '#fffaee',
      navigationEnabled: '#fffaee',
      onEnabled: '#7451eb',
      onHover: '#7451eb',
      onSelected: '#7451eb',
      selected: '#fffaee',
    },
    onEnabled: '#fffaee',
    onHover: '#fffaee',
    onSelected: '#ffffff',
    selected: '#7451eb',
  },
  layout: {
    background: {
      alternative: '#fffaee',
      dashboard: '#f9f8f9',
      funnel: '#f9f8f9',
      main: '#ffffff',
      navigation: '#ffffff',
      navigationAlternative: '#f9f8f9',
      overlay: '#271a3880',
      video: '#271a38',
    },
    line: {
      border: '#dad9dc',
      divider: '#dad9dc',
      outline: '#dad9dc',
      title: '#dad9dc',
    },
    surface: {
      alternativeBackground: '#fffaee',
      background: '#ffffff',
      border: '#f2f1f3',
      tooltip: '#271a38',
    },
  },
  menu: {
    background: {
      selected: {
        enabled: '#f6f4fd',
        hover: '#ece9fb',
      },
      unselected: {
        enabled: '#ffffff',
        hover: '#f2f1f3',
      },
    },
  },
  notification: {
    danger: {
      background: '#fcebeb',
      main: '#d50000',
    },
    error: {
      background: '#fcebeb',
      main: '#d50000',
    },
    info: {
      background: '#ecf7fd',
      main: '#0277bd',
    },
    neutral: {
      background: '#f9f8f9',
      main: '#605b68',
    },
    valid: {
      background: '#eef5ef',
      main: '#2e7e32',
    },
    warning: {
      background: '#fff1ed',
      main: '#ff5722',
    },
  },
  progress: {
    completion: {
      active: '#7451eb',
      disabled: {
        active: '#605b68',
        enabled: '#f2f1f3',
        expected: '#c3bfc7',
      },
      enabled: '#ece9fb',
      expected: '#dad3f8',
    },
    event: {
      awaitingFeedback: '#0277bd',
      canceled: '#605b68',
      completed: '#2e7e32',
      noShow: '#d50000',
      ongoing: '#8a76e8',
      scheduled: '#605b68',
    },
    learningAsset: {
      awaiting: '#0277bd',
      background: {
        acquired: '#eef5ef',
        main: '#ffffff00',
        passed: '#2e7e32',
      },
      failed: '#d50000',
      inProgress: '#2e7e32',
      locked: '#605b68',
      notStarted: '#605b68',
      onPassed: '#fffaee',
      passed: '#2e7e32',
      readyToPresent: '#2e7e32',
      retry: '#ff5722',
    },
  },
  skeleton: {
    badge: '#ece9fb',
    image: '#dad3f8',
    text: '#ece9fb',
  },
  social: {
    apple: '#000000',
    facebook: '#1877f2',
    google: '#3c4043',
    hover: '#271a3829',
    linkedin: '#0077b5',
    youtube: '#ff0000',
  },
  sort: {
    disabled: '#605b68',
    enabled: '#605b68',
    selected: '#271a38',
  },
  tag: {
    blue: {
      main: '#0277bd',
      onMain: '#fffaee',
      onSecondary: '#271a38',
      secondary: '#ecf7fd',
    },
    crimson: {
      main: '#950000',
      onMain: '#fffaee',
      onSecondary: '#271a38',
      secondary: '#fcebeb',
    },
    green: {
      main: '#2e7e32',
      onMain: '#fffaee',
      onSecondary: '#271a38',
      secondary: '#eef5ef',
    },
    grey: {
      main: '#605b68',
      onMain: '#fffaee',
      onSecondary: '#271a38',
      secondary: '#f9f8f9',
    },
    neutral: {
      main: '#ffffff00',
      onMain: '#271a38',
      onSecondary: '#271a38',
      secondary: '#ffffff00',
    },
    orange: {
      main: '#f9ab2d',
      onMain: '#271a38',
      onSecondary: '#271a38',
      secondary: '#fff1ed',
    },
    purple: {
      main: '#7451eb',
      onMain: '#fffaee',
      onMainMinor: '#605b68',
      onSecondary: '#271a38',
      secondary: '#ece9fb',
    },
    red: {
      main: '#d50000',
      onMain: '#fffaee',
      onSecondary: '#271a38',
      secondary: '#fdf5f5',
    },
    yellow: {
      main: '#f2e93f',
      onMain: '#271a38',
      onSecondary: '#271a38',
      secondary: '#fdfbe0',
    },
  },
  text: {
    onContrasted: '#fffaee',
    onMain: '#271a38',
    onMainDisabled: '#605b68',
    onMainMinor: '#605b68',
    onMainSecondary: '#271a38',
    onTooltip: '#fffaee',
  },
  topic: {
    accounting: {
      background: '#f4ecfa',
      detail: '#e9daf5',
      primary: '#7315c1',
      thumbnail: '#d2b4eb',
    },
    business: {
      background: '#ebeefb',
      detail: '#d6dcf7',
      primary: '#0026ca',
      thumbnail: '#adbaee',
    },
    career: {
      background: '#f8f0fa',
      detail: '#f2e2f4',
      primary: '#ab47bc',
      thumbnail: '#e4c4ea',
    },
    cyberSecurity: {
      background: '#f0f2f3',
      detail: '#e1e5e6',
      primary: '#455a64',
      thumbnail: '#c4cacd',
    },
    data: {
      background: '#ebf1f0',
      detail: '#d6e3e0',
      primary: '#004d40',
      thumbnail: '#adc6c2',
    },
    design: {
      background: '#fcedf6',
      detail: '#f9dbe6',
      primary: '#d81b60',
      thumbnail: '#f3b6cc',
    },
    development: {
      background: '#ebf5f6',
      detail: '#d6ebed',
      primary: '#00838f',
      thumbnail: '#add7db',
    },
    energy: {
      background: '#f8f3eb',
      detail: '#f1e7d7',
      primary: '#a56703',
      thumbnail: '#e2ceae',
    },
    healthSocialEarlyChildhood: {
      background: '#f6eef7',
      detail: '#ecddee',
      primary: '#892b99',
      thumbnail: '#d9bbde',
    },
    hr: {
      background: '#ecebf4',
      detail: '#d9d6e9',
      primary: '#140078',
      thumbnail: '#b4add4',
    },
    management: {
      background: '#edeff7',
      detail: '#dbdeef',
      primary: '#1b349e',
      thumbnail: '#b6bee0',
    },
    marketingComs: {
      background: '#eef1ff',
      detail: '#dee3ff',
      primary: '#304ffe',
      thumbnail: '#bdc7ff',
    },
    other: {
      background: '#f6f4fd',
      detail: '#ece9fb',
      primary: '#7451eb',
      thumbnail: '#dad3f8',
    },
    pedagogy: {
      background: '#fef0ef',
      detail: '#fde1df',
      primary: '#d63d46',
      thumbnail: '#fcc3bf',
    },
    pm: {
      background: '#f1eef8',
      detail: '#e3ddf1',
      primary: '#512da8',
      thumbnail: '#c7bce3',
    },
    productivitySoftwares: {
      background: '#f2f4f7',
      detail: '#e5e9ee',
      primary: '#5c7497',
      thumbnail: '#cbd3de',
    },
    si: {
      background: '#ebf4fa',
      detail: '#d7e9f4',
      primary: '#0f5b88',
      thumbnail: '#aed4ea',
    },
    softSkills: {
      background: '#f4f1f0',
      detail: '#eae4e2',
      primary: '#795548',
      thumbnail: '#d4c9c4',
    },
    supplyChain: {
      background: '#f9f1eb',
      detail: '#f4e3d6',
      primary: '#b94e00',
      thumbnail: '#e9c6ad',
    },
  },
  videocall: {
    active: {
      border: '#dad3f8',
      enabled: '#f6f4fd',
      hover: '#dad3f8',
      icon: '#7451eb',
    },
    danger: {
      enabled: '#e96b7c',
      hover: '#e96b7ca3',
    },
    default: {
      border: '#dad9dc',
      enabled: '#f9f8f9',
      hover: '#dad9dc',
      icon: '#605b68',
    },
    warning: {
      border: '#ffc9b8',
      enabled: '#fff1ed',
      hover: '#ffc9b8',
      icon: '#ff5722',
    },
  },
};
export default tokens;
